/**
 * `html.cm-home-route` — el candado que distingue la home de todo lo demas.
 *
 * De el cuelgan dos cosas en `less/forum.less` §4/§4c: que se vea la landing `#cm-home` y
 * que NO se vea el IndexPage (sidebar + lista de discusiones). Vale exactamente para `/`.
 *
 * POR QUE NO SIRVE LA CLASE DE MITHRIL. `App--index` la llevan tambien `/discusiones` y
 * `/t/<slug>`, que montan el mismo `IndexPage`; usarla colaria la landing en cada categoria
 * (bug real de T02, ver el comentario de §4). Y `Page.oninit` tampoco vale como disparador:
 * cuando dos rutas resuelven al MISMO componente — `/` y `/discusiones` lo hacen — Mithril
 * diffea en vez de remontar y `oninit` no se vuelve a ejecutar.
 *
 * De ahi el envoltorio de `history`: Mithril navega con `pushState`, que no dispara
 * `popstate`. Es el mismo mecanismo que el script de `custom_header` lleva corriendo en
 * produccion desde T02, y por eso esta funcion se hace a un lado si ese script ya esta
 * presente (`window.__cmHomeRouteSync`): en el foro con landing inyectada mandaria el de
 * siempre, y aqui solo queda el camino para cuando la landing viva ya en la extension.
 *
 * GEMELO Y HUECO DE COBERTURA — leer antes de tocar nada. El original vive en
 * `docs/operations/assets/2026-08-04-flarum-t02-theme/cm-home.html` §0; los dos tienen que
 * comportarse igual. Y como el staging sirve ese `custom_header`, en la suite e2e SIEMPRE
 * gana el de alla: las specs que miran `cm-home-route` (d1, d2, dark) verifican el HTML, no
 * este modulo. Su rama propia solo entrara en juego el dia que la landing se convierta en
 * componente y `custom_header` se retire — ese dia hay que anadirle specs, porque hoy no
 * tiene ninguna.
 */
declare global {
  interface Window {
    __cmHomeRouteSync?: () => void;
    __cmRegisterPath?: string;
  }
}

export default function homeRouteClass() {
  if (window.__cmHomeRouteSync) {
    // El `custom_header` ya sincroniza la clase: dos envoltorios harian el mismo trabajo dos
    // veces. Se respeta el que ya esta y solo se fuerza una pasada por si esta funcion llega
    // antes de la primera navegacion.
    window.__cmHomeRouteSync();
    return;
  }

  const sync = () => {
    const path = window.location.pathname;
    document.documentElement.classList.toggle('cm-home-route', path === '/' || path === '');
  };

  (['pushState', 'replaceState'] as const).forEach((method) => {
    const original = history[method];
    history[method] = function (this: History, ...args: any[]) {
      const result = original.apply(this, args as any);
      sync();
      return result;
    } as any;
  });

  window.addEventListener('popstate', sync);
  window.__cmHomeRouteSync = sync;
  sync();
}
